

(function(){

    angular.module('tmx-app').controller('companyBranchesCtrl', ['$scope', '$state','BranchService',
        '$mdSidenav','resolvedData','tmxUtility','menu', 
    
        function CompanyBranchesCtrl($scope, $state, BranchService, $mdSidenav, resolvedData, tmxUtility,menu){

            var branchVM=this;
            branchVM.EntityName = "CompanyBranches";
            var exists;
            var copy;
            exists = tmxUtility.exists;
            copy = tmxUtility.copy;
            branchVM.isPageLoading = false;

        ///////////////////////// CHECKING PRIVILEGES OF THIS ENTITY///////////////////////////////////////////////////////
            branchVM.menu = menu;
            branchVM.Privileges = [];
            branchVM.ViewPrivilege = false;
            branchVM.EditPrivilege = false;
            branchVM.DeletePrivilege = false;
            branchVM.AddPrivilege = false;
            branchVM.checkPermission = tmxUtility.checkPermission;
                   
            branchVM.editPermission= branchVM.checkPermission("Private.Masterdata.CompanyBranches","Edit");            
            branchVM.viewPermission= branchVM.checkPermission("Private.Masterdata.CompanyBranches","View");          


        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.query = "Company";
            branchVM.gridData = new kendo.data.ObservableArray([]);
            branchVM.date = new Date().toJSON();
            if(angular.isDefined(BranchService.filterColumn)) {
                branchVM.cols = BranchService.filterColumn;
            }
            branchVM.nav = "SearchSideNav";
            branchVM.schema = BranchService.schema;
            branchVM.cloneColumn = BranchService.gridColumn;
            branchVM.BranchService = BranchService;
            branchVM.locations = resolvedData.Locations;
            branchVM.Managers = resolvedData.Managers;
            branchVM.companies = resolvedData.Companies;
            branchVM.isOpen=function(navName){
                if($mdSidenav(navName).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            }
        ///////////////////////////*************Functions****************/////////////////////////////////////////////////////
            branchVM.reload=function(){
                branchVM.container.branchGrid.dataSource.read();
            };
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.checkAddDisabled = function(){
                if($mdSidenav(branchVM.nav).isOpen()){
                    return true;
                }
                else{
                    return false;
                }
            };
        /////////////////////////// FILTERED FUNCTION TO APPLY FA-FILTER ICON on SEARCH RESULTS///////////////////////////////
            branchVM.isFiltered=function(fieldName){
             
                var filtered = false;
                if(fieldName == "Status"){
                    fieldName="EffectiveEndDate";
                }
                if(angular.isDefined(branchVM.filters)){
                    branchVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName){
                            filtered = true;
                        }
                    });
                }
                return filtered;
            };
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.success=function(promise){
                if(promise.read==true) {
                    branchVM.container.branchGrid.dataSource.transport.read(promise);
                }
                else {
                    branchVM.container.branchGrid.dataSource.read();
                }
                branchVM.toggle(branchVM.nav);
            };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ///////// CHECKS IF ON MAIN GRID OR ON CHILD STATE ///////////////////////////////////////////////////////////////////
            branchVM.onChildState=function(){
                if($state.current.name.indexOf(".add")>0 || $state.current.name.indexOf(".edit")>0) return true;
            } ;
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////// ADD STATE //////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.new = function(){
            //branchVM.searchClear = true;
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".add");
            };
////////////EDIT STATE////////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.clickEdit = function (item) {
            //branchVM.searchClear = true;
                $state.data.info = false;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyBranchId});
            };
/////////////VIEW STATE////////////////////////////////////////////////////////////////////////////////////////////////
            branchVM.clickView = function (item) {
                $state.data.info = true;
                localStorage.setItem("ViewState", JSON.stringify($state.data.info));
                $state.go($state.current.name+".edit",{"Id":item.CompanyBranchId});
            } ;

//////////// ACTIVATE BRANCH CLICK/////////////////////////////////////////////////////////////////////////////////////
//  branchVM.clickActive = function (item) {
//     var confirm = $mdDialog.confirm()
//              .title('Activate Company Branch '+item.BranchName+" ?")
//              .textContent('Are you sure you want to activate this branch?')
//              .ariaLabel('Lucky day')
//              .clickOutsideToClose(true)
//              // .targetEvent(ev)
//              .ok('Yes')
//              .cancel('Cancel');
//
//        $mdDialog.show(confirm).then(function() {
//            item.$activate(item.CompanyBranchId).then(function(result)
//            {
//              branchVM.container.branchGrid.dataSource.read();
//            });
//        }, function() {
//
//    });
// } ;
////////////DEACTIVATE BRANCH CLICK////////////////////////////////////////////////////////////////////////////////////
//  branchVM.clickInactive = function (item) {
//    //       var confirm = $mdDialog.confirm()
//    //          .title('Deactivate Company Branch '+item.BranchName+" ?")
//    //          .textContent('Are you sure you want to deactivate this branch?')
//    //          .ariaLabel('Lucky day')
//    //          .clickOutsideToClose(true)
//    //          // .targetEvent(ev)
//    //          .ok('Yes')
//    //          .cancel('Cancel');
//    //
//    //    $mdDialog.show(confirm).then(function() {
//    //        item.$deactivate(item.CompanyBranchId).then(function(result)
//    //        {
//    //          branchVM.container.branchGrid.dataSource.read();
//    //        });
//    //    }, function() {
//    //
//    //});
//      var diagConfig={
//          action:"Deactivate",
//          entity:"Company Branch",
//          entityname:item.BranchName,
//          details:[
//              {value:item.BranchCode,label:"Branch Code"},
//              {value:item.BranchName, label:"Branch Name"},
//              {value:item.BranchDescription, label:"Branch Descriptions"}
//          ],
//          options:[
//              {label:"Deactivate",value:true,class:"md-warn"},
//              {label:"Cancel",value:false,class:"md-primary"}
//          ]
//      };
//      function callback(ok) {
//          if(ok){
//              branchVM.Deactivate(item);
//          }
//      }
//      var companyBranchesDeactivateDialog=new TmxDialogService.confirmDialog(diagConfig,callback);
//
//      companyBranchesDeactivateDialog.show();
//
//        }
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//  branchVM.Deactivate = function(item) {
//      item.$deactivate(item.CompanyBranchId).then(function(result)
//           {
//            if(angular.isDefined(result))
//            {
//             if(result.status>=400)
//             {
//              showCustomToast("error",result.data.Message);
//             }
//            }
//            branchVM.container.branchGrid.dataSource.read();
//           });
//    };
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////*******************Kendo row template functions****************************//////////////////////////////
            branchVM.dataObj ={value: "empty"};
        //////////////// CHECK BRANCH STATUS///////////////////////////////////////////////////////////////////////////////
            branchVM.isStatusActive=function(status){
                if(status=="Active"){return true;}
                return false;
            };
            branchVM.status=function(dataitem){
                return dataitem.Status;
            //if(dataitem.EffectiveEndDate<branchVM.date)
            //{
            //    return "Inactive";
            //}
            //return "Active";
            };
           
/////////////////////// KENDO GRID ROW POPULATE FUNCTIONS/////////////////////////////////////////////////////////////
            branchVM.formatBranchName=function(dataitem) {
                return tmxUtility.sliceText(dataitem.BranchName,25);
            };
            branchVM.getCompany=function(dataitem){
                if(angular.isDefined(BranchService.lookup.companiesLovs) && BranchService.lookup.companiesLovs.length>0) {
                    for (var i = BranchService.lookup.companiesLovs.length - 1; i >= 0; i--) {
                        if(BranchService.lookup.companiesLovs[i].HiddenValue==dataitem.CompanyId) {
                            return BranchService.lookup.companiesLovs[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            };
            branchVM.getLocation=function(dataitem){
                if(angular.isDefined(BranchService.lookup.locationLovs) && BranchService.lookup.locationLovs.length>0) {
                    for (var i = BranchService.lookup.locationLovs.length - 1; i >= 0; i--) {
                        if(BranchService.lookup.locationLovs[i].HiddenValue==dataitem.LocationId) {
                            return BranchService.lookup.locationLovs[i].VisibleValue;
                        }
                    }
                }
                return "N/A";
            };

            branchVM.getManager=function(UserName){
                if (UserName){
                    return UserName;                        
                }
                else{
                    return "N/A";
                }
            };


            branchVM.getBranchPhoneNumber=function(BranchPhoneNumber1){

                if(angular.isDefined(BranchPhoneNumber1) && BranchPhoneNumber1!=null) {
                    return "+"+BranchPhoneNumber1;               
                }
                return "";
            };

//*******************KENDO*********************//

            branchVM.gridColumns = BranchService.columns;

            branchVM.mainGridOptions = {
                dataSource: {

                    transport: {
                        read: function(o){
                            if(angular.isDefined(branchVM.searchClear) && branchVM.searchClear==false){
                                if(exists(branchVM.o)){
                                    copy(branchVM.o.data,["filter"],o.data);
                                }
                            }
                            branchVM.searchClear = false;
                            if(branchVM.onChildState()){return;}
                         
                            if(!o.fromSideNav) {
                                if($state.searchClear){
                                    branchVM.searchClear = true;
                                    $state.searchClear=undefined;
                                //return;
                                }
                            //if(exists(branchVM.o))
                            //    copy(branchVM.o.data,["filter"],o.data);
                            }
                            else{
                                o.data.firstPage = true;
                            }

                            branchVM.o = angular.copy(o);
                            
                            branchVM.filters = branchVM.o.data.filter;
                            branchVM.isPageLoading = true;
                            BranchService.getByParams(o,true).then(function(response){
                                parseResppnse(response.data);
                                branchVM.excelData=response;
                                o.success(response);
                                branchVM.isPageLoading = false;
                            });
                        },
                        
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: [{field: "CompanyBranchId", dir: "desc"}],
                },
                excelExport: function(e) {                              
                    var sheet = e.workbook.sheets[0];
                    var data = branchVM.excelData.data;
                    var gridColumns = branchVM.container.branchGrid.columns;                    
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                    
                    sheet.rows = rows;                                                                 
                },            
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                pdf: {
                    allPages: true,
                    fileName: "CompanyBranches.pdf"
                },
                excel: {
             /*   allPages: true,*/
                    fileName: "CompanyBranches.xlsx"
                },
            // filterable:true,
                sortable: true,
                scrollable: false,
            // groupable: true,
                rowTemplate:kendo.template($("#rowTemplate").html()),
            // rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': DeviceManagementCtrl.isStatusActive(dataItem)}\"><td><md-button class='tmx-primary-text' ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' ng-click='DeviceManagementCtrl.clickEdit(dataItem)'> #= deviceDeviceName # </md-button></td><td> \{\{DeviceManagementCtrl.getUser(dataItem)\}\}   </td><td> \{\{DeviceManagementCtrl.formatPhoneNumber(dataItem)\}\} </td><td>#= deviceDeviceImei # </td><td> \{\{DeviceManagementCtrl.formatManufacturer(dataItem)\}\} </td><td> \{\{DeviceManagementCtrl.status(dataItem)\}\}   </td><td><md-menu flex='none' class='menu-list-item' ><md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button><md-menu-content width='2' ><md-menu-item><md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Delete Device</md-button></md-menu-item><md-menu-item><md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Device Info</md-button></md-menu-item><md-menu-item ng-if='!DeviceManagementCtrl.isStatusActive(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickInactive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate Device</md-button></md-menu-item><md-menu-item ng-if='DeviceManagementCtrl.isStatusActive(dataItem)'><md-button  aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickActive(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>check_circle</md-icon>Activate Device</md-button></md-menu-item><md-menu-item><tmx-duplicate disable='DeviceManagementCtrl.isStatusActive(dataItem)' model='dataItem' schema='DeviceManagementCtrl.schema' columns='DeviceManagementCtrl.cloneColumn' on-submit='DeviceManagementCtrl.reload()'> </tmx-duplicate></td></md-menu-item></md-menu-content></md-menu></td></tr>", <td> \{\{CompanyBranchesCtrl.getContactPerson(dataItem)\}\} </td><td> \{\{CompanyBranchesCtrl.getContactPhoneNumber(dataItem)\}\} </td>
                columns: BranchService.columns
            };

            branchVM.container = {};
            $state.data={
                grid: branchVM.container,
                info: false
            };

//*************Filter******************//
//************for filtering/search************
            branchVM.searchSideNavActive=false;

            branchVM.toggleSearch=function(){
                if(branchVM.searchSideNavActive) {
                    branchVM.searchData = {};
                    branchVM.searchSideNavActive=false;
                }
                else
                    branchVM.searchSideNavActive=true;
                branchVM.toggle('SearchSideNav');
            }
            branchVM.exportSideNavActive=false;

            branchVM.toggleExport=function(){
                if(branchVM.exportSideNavActive)
                    branchVM.exportSideNavActive=false;
                else
                    branchVM.exportSideNavActive=true;
                branchVM.toggle('ExportSideNav');
            }
            branchVM.toggle = function(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function() {
                    });
            };
            branchVM.filt = {};
            branchVM.search = function(navID) {

                let calls=[];


                for (var key in branchVM.searchData) {
                    if (branchVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: branchVM.searchData[key]
                        });
                    }
                }

                branchVM.filt = {
                    filters: calls,
                    logic: "and"
                };
                branchVM.o.data.filter = branchVM.filt;
                branchVM.container.branchGrid.dataSource.transport.read(branchVM.o);

                branchVM.searchData = {};
                branchVM.toggle(navID);
            };
            branchVM.clear = function(navID) {
                branchVM.searchData = {};
                branchVM.toggle(navID);
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){
                    dataItem.BranchPhoneNumber1=branchVM.getBranchPhoneNumber(dataItem.BranchPhoneNumber1);
                    dataItem.UserName=branchVM.getManager(dataItem.UserName);
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);
                    dataItem.BranchName=tmxUtility.sliceText(dataItem.BranchName,25);
                    dataItem.statusActive = branchVM.isStatusActive(dataItem.Status);
                });
            }

        }]);//controller function end

})();
